<template>
  <div class="terminal-details">
    <enfold>
      <div class="td-title">
        <img src="@/assets/images/public/public_return.png" @click="$router.go(-1)" alt />
      </div>
      <div class="td-content">
        <div class="td-left">
          <ul>
            <li>
              <em>{{ $t('cdck1') }}:</em>
              <span class="ellipsis-1">{{deviceInfo.name}}</span>
            </li>
            <li>
              <em>{{ $t('cdck2') }}:</em>
              <span>{{deviceInfo.group_name}}</span>
            </li>
            <li>
              <em>{{ $t('cdck3') }}:</em>
              <span>{{deviceInfo.size_remark}}</span>
            </li>
            <li>
              <em>{{ $t('cdck4') }}:</em>
              <span :style="`color:${deviceInfo.run_state.stateColor}`">
                {{deviceInfo.run_state.stateName}}
              </span>
            </li>
            <li>
              <em>{{ $t('cdck5') }}:</em>
              <span class="ellipsis-1">{{deviceInfo.last_heartbeat}}</span>
            </li>
          </ul>
        </div>
        <div class="td-right">
          <el-tabs class="device-tab" v-model="deviceTab.activeName" @tab-click="handleClick">
            <el-tab-pane class="dt-pane" :label="$t('cdck6')" name="schedule_play">
              <el-table :data="playScheduleData" class="dt-schedule_play" height="100%" row-key="row_key" :tree-props="{children: 'materials'}">
                <el-table-column prop="ref_name" :label="$t('cdck7')" width="200">
                </el-table-column>
                <el-table-column prop="date_interval" :label="$t('cdck8')" width="184px">
                </el-table-column>
                <el-table-column prop="validweek" :label="$t('cdck9')" width="">
                </el-table-column>
                <el-table-column prop="play_interval" :label="$t('cdck10')">
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane class="dt-pane" :label="$t('cdck11')" name="playlist">
              <el-table v-if="devicePlaylistData" height="100%" :data="devicePlaylistData">
                <el-table-column type="index" width="50" :label="$t('cdck12')"></el-table-column>
                <el-table-column prop="name" :label="$t('cdck13')"></el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane class="dt-pane" :label="$t('cdck14')" name="playing_view">
              <div class="playing_view">
                <div class="pv-con" v-loading="liveLoading" :element-loading-text="$t('cdck15')" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
                  <div class="live-box" v-show="!noSignal">
                    <video ref="live" width="100%"></video>
                  </div>
                  <p v-show="noSignal">{{ $t('cdck16') }}</p>
                </div>
                <div class="pv-change" @click="refreshSignal">
                  <i>
                    <img src="@/assets/images/public/public_refresh.png" width="100%" alt="">
                  </i>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
          <!--          <video ref="deviceLive"></video>-->
        </div>
      </div>
    </enfold>
  </div>
</template>

<script>
import enfold from '@/components/basics/Enfold';
import { liveKommander } from "@/assets/scripts/flvPlayer";
import { formatDate, daysWeek } from "@/assets/scripts/publicFunction";
import { runStateInfo } from "@/assets/scripts/runState";
import { hmsToSec, secToHMS } from "@/assets/scripts/publicFunction";

const LIVE_KOMMANDER = `${process.env.VUE_APP_FLV}?port=1935&app=live_kommander&stream=`
const RTMP_KOMMANDER = process.env.VUE_APP_RTMP;
export default {
  name: "KommanderDetails",
  data() {
    return {
      deviceId: '',
      deviceSn: '',
      ksId: 0,
      deviceInitialData: null,
      deviceInfo: {
        name: '',
        group_name: '',
        size_remark: '',
        group_run_status: '',
        run_state: {
          stateColor: "#ea1a1a",
          stateName: "离线"
        },
        last_heartbeat: ''
      },
      deviceTab: {
        activeName: 'schedule_play',
        tabList: [
          {
            name: 'schedule_play',
            label: this.$t('cdck18')
          },
          {
            name: 'playlist',
            label: this.$t('cdck19')
          },
          {
            name: 'playing_view',
            label: this.$t('cdck20')
          }]
      },
      playScheduleData: [],
      devicePlaylistData: [],
      prePlayId: 0,
      myWebSocket: null,
      flvUrl: null,
      flvPlayer: null,
      liveLoading: true,
      noSignal: false,
      timer: {
        rtmp_push: 0,
        rtmp_noSignal: 0
      },
      playSucc: false
    }
  },
  methods: {
    liveStart() {
      if (parseInt(this.deviceInitialData.run_state) !== 0) {
        console.log(this.$flvjs);
        this.liveLoading = true;
        this.noSignal = false;
        this.playSucc = false;
        this.flvPlayer = liveKommander(this.$refs.live, this.flvUrl);
        clearTimeout(this.timer.rtmp_push);
        clearTimeout(this.timer.rtmp_noSignal);
        this.timer.rtmp_push = setTimeout(() => {
          let msg = {
            role: 'web',
            from: 'kommander_rtmp_push_start',
            data: {
              rtmp_push_info: {
                canvas: {
                  signal_source: 'canvas',
                  host: RTMP_KOMMANDER,
                  app_name: 'live_kommander',
                  stream_name: `ks_${this.ksId}_canvas`
                }
              }
            }
          };
          this.myWebSocket.send(JSON.stringify(msg));
        }, 5000);
        this.timer.rtmp_noSignal = setTimeout(() => {
          this.liveLoading = false;
          this.noSignal = true;
        }, 10000)
        this.flvPlayer.on(this.$flvjs.Events.METADATA_ARRIVED, ev => {
          console.log('METADATA_ARRIVED-----ON----->', ev);
          this.liveLoading = false;
          clearTimeout(this.timer.rtmp_push);
          clearTimeout(this.timer.rtmp_noSignal);
          let msg = {
            role: 'web',
            from: 'rtmp_stream_connect',
            data: {
              rtmp_push_info: {
                canvas: {
                  signal_source: 'canvas',
                  host: RTMP_KOMMANDER,
                  app_name: 'live_kommander',
                  stream_name: `ks_${this.ksId}_canvas`
                }
              }
            }
          };
          // 成功拉流，将自己添加进该条rtmp流的计数器
          !this.playSucc && this.myWebSocket.send(JSON.stringify(msg))
          this.flvPlayer.play();
          this.playSucc = true;
        });
        this.flvPlayer.on(this.$flvjs.Events.RECOVERED_EARLY_EOF, ev => {
          console.log('RECOVERED_EARLY_EOF-----ON----->', ev);
        });
        this.flvPlayer.off("media_info", ev => {
          console.log('media_info-----off----->', ev);
        });
        console.log(this.flvPlayer);
      } else {
        this.liveLoading = false;
        this.noSignal = true;
      }
    },
    initDeviceInfo() {
      this.$http.post("/admin/device/detail", { id: this.deviceId }, data => {
        this.deviceInfo.name = data.name;
        this.deviceInfo.group_name = data.group_name;
        this.deviceInfo.size_remark = data.size_remark;
        this.deviceInfo.run_state = runStateInfo(data.run_state, data.group_run_status);
        this.deviceInfo.last_heartbeat = formatDate(new Date(data.last_heartbeat * 1000), 'yyyy-MM-dd hh:mm:ss');
        this.deviceInitialData = data;
      });
    },
    getPlaySchedule() {
      this.$http.post("/admin/device/getPlaySchedule", { id: this.deviceId }, data => {
        if (data) {
          for (let item of data) {
            // 由于组件要求，而数据有所不同，所以把节目名称使用素材名称来代替，适应树形数据
            item.row_key = `${item.schedule_id}_${item.play_id}`;
            item.ref_name = item.play_name;
            item.date_interval = parseInt(item.isdatelimit) ? `${item.start_date}-${item.end_date}` : '-';
            item.validweek = parseInt(item.validweek) ? daysWeek(item.validweek) : '-';
            item.play_interval = `${item.start_time}-${item.end_time}`;
            let startTime_temp = hmsToSec(item.start_time);
            for (let val of item.materials) {
              val.play_id = item.play_id;
              val.row_key = `${item.row_key}_${val.material_id}`;
              val.play_name = item.play_name;
              val.isdatelimit = item.isdatelimit;
              val.start_date = item.start_date;
              val.end_date = item.end_date;
              val.date_interval = `${item.start_date}-${item.end_date}`;
              val.isweeklimit = item.isweeklimit;
              val.validweek = parseInt(item.validweek) ? daysWeek(item.validweek) : '-';
              val.start_time = item.start_time;
              val.end_time = item.end_time;
              startTime_temp = startTime_temp + parseInt(val.ref_time);
              val.play_interval = `${item.start_time}-${secToHMS(startTime_temp)}`;
            }
          }
        }
        data && (this.playScheduleData = data);
        console.log(this.playScheduleData);
      });
    },
    getDevicePlaylist() {
      this.$http.post("/admin/device/getDevicePlaylist", { id: this.deviceId }, data => {
        this.devicePlaylistData = data;
        console.log('devicePlaylistData------>', this.devicePlaylistData);
      });
    },
    handleClick() {
      switch (this.deviceTab.activeName) {
        case 'schedule_play':
          this.getPlaySchedule();
          break;
        case 'playlist':
          this.getDevicePlaylist();
          break;
        case 'playing_view':
          this.liveStart();
          // console.log(this.flvPlayer);
          break;
      }
    },
    refreshSignal() {
      console.log(parseInt(this.deviceInitialData.run_state));
      if (parseInt(this.deviceInitialData.run_state)) {
        this.disconnectRtmpStream();
        this.flvPlayer && this.flvPlayer.destroy();
        this.liveStart();
      }
    },
    disconnectRtmpStream() {
      this.playSucc && this.myWebSocket.send(JSON.stringify({
        role: 'web',
        from: 'rtmp_stream_disconnect',
        data: {
          rtmp_push_info: {
            canvas: {
              signal_source: 'canvas',
              host: RTMP_KOMMANDER,
              app_name: 'live_kommander',
              stream_name: `ks_${this.ksId}_canvas`
            }
          }
        }
      }));
    }
  },
  created() {
    // 通过路由获取id与sn
    this.deviceId = this.$route.params.id;
    this.deviceSn = this.$route.params.sn;
    this.ksId = this.$route.params.ks_id;
    // 当获取的ID或者SN为空时返回上一级路由页面
    this.deviceId || this.deviceSn ? '此处可以进行HTTP请求' : this.$router.go(-1);
    this.initDeviceInfo();
    this.getPlaySchedule();
    this.flvUrl = LIVE_KOMMANDER + `ks_${this.ksId}_canvas`;
    this.myWebSocket = this.$store.getters.myWebSocket;
  },
  watch: {
    'deviceTab.activeName'(n, o) {
      if (o === 'playing_view') {
        this.disconnectRtmpStream();
        this.flvPlayer.destroy();
        this.flvPlayer = null;
      }
    }
  },
  components: {
    enfold
  },
  beforeDestroy() {
    this.disconnectRtmpStream();
    this.flvPlayer && this.flvPlayer.destroy();
  }
}
</script>

<style lang="scss" scoped>
.terminal-details {
  width: 100%;
  height: 100%;

  .td-title {
    height: 60px;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    img {
      width: 30px;
      margin-left: 20px;
    }

    border-bottom: 2px solid #d7ecf3;
  }

  .td-content {
    height: calc(100% - 60px);
    max-height: 620px;
    display: flex;
    align-items: center;

    .td-left {
      width: 30%;
      height: 100%;
      flex-shrink: 0;
      overflow-x: hidden;
      overflow-y: auto;

      ul {
        padding: 0 16px;

        li {
          padding: 0 2px;
          display: flex;
          align-items: center;
          height: 60px;

          &:not(:last-of-type) {
            border-bottom: solid 1px #eaeaea;
          }

          em {
            width: 86px;
            flex-shrink: 0;
            text-align: right;
            color: #999;
          }

          span {
            flex-grow: 1;
          }
        }
      }
    }

    .td-right {
      height: 100%;
      flex-grow: 1;
      border-left: solid 2px #d7ecf3;

      /deep/ .device-tab {
        height: 100%;

        .el-tabs__header {
          padding: 0;
          position: relative;
          margin: 0 0 2px;
        }

        .el-tabs__content {
          height: calc(100% - 40px);

          .el-table__row--level-1 {
            color: #9f9f9f;
          }
        }

        .dt-pane {
          height: 100%;

          .playing_view {
            width: 84%;
            height: 63%;
            margin: auto;
            padding-top: 5px;
            .pv-con {
              width: 100%;
              height: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
              background: #00000080;
              .live-box {
                width: 100%;
                height: 100%;
              }
              p {
                color: #fff;
              }
            }

            .pv-change {
              width: 100%;
              height: 32px;
              margin-top: 5px;
              padding-left: 3px;
              display: flex;
              align-items: center;
              & > i {
                width: 32px;
                height: 32px;
              }
            }
          }
        }

        /deep/ #tab-schedule_play {
          padding-left: 20px;
        }

        /deep/ .dt-schedule_play {
          tbody {
            overflow-y: auto;
          }
        }
      }
    }

    video {
      width: 100%;
    }
  }
}
</style>
